var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    [
      _c(
        "q-collapsible",
        {
          staticClass: "filter",
          attrs: {
            icon: "fas fa-filter",
            label: _vm.$t("filter"),
            opened: !_vm.$q.platform.is.mobile ? true : false
          }
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "" } },
            [
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("q-search", {
                        attrs: {
                          placeholder: _vm.$t("search"),
                          icon: "fas fa-search",
                          debounce: 600
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("progress")))
                      ]),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("all"),
                              value: "all",
                              icon: "fas fa-list"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("in_progress"),
                              value: "in-progress",
                              icon: "fas fa-shoe-prints"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("to_do"),
                              value: "to-do",
                              icon: "far fa-edit"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("finished"),
                              value: "finished",
                              icon: "far fa-check-circle"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("favorites")))
                      ]),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("all"),
                              value: "all",
                              icon: "fas fa-list"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.favorite,
                          callback: function($$v) {
                            _vm.favorite = $$v
                          },
                          expression: "favorite"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("favorites"),
                              value: "favorites",
                              icon: "far fa-heart"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.favorite,
                          callback: function($$v) {
                            _vm.favorite = $$v
                          },
                          expression: "favorite"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.country_areas.length > 0
                ? _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("areas")))
                          ]),
                          _vm._l(_vm.country_areas, function(area, index) {
                            return _c(
                              "q-item",
                              { key: index, attrs: { tag: "label", link: "" } },
                              [
                                _c(
                                  "q-item-side",
                                  [
                                    _c("q-checkbox", {
                                      attrs: { val: area.value },
                                      on: { input: _vm.changeFilter },
                                      model: {
                                        value: _vm.areas,
                                        callback: function($$v) {
                                          _vm.areas = $$v
                                        },
                                        expression: "areas"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item-main",
                                  [
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass: "text-weight-light",
                                        attrs: { label: "" }
                                      },
                                      [_vm._v(_vm._s(area.label))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.groups_user.length > 0
                ? _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("groups")))
                          ]),
                          _vm._l(_vm.groups_user, function(group, index) {
                            return _c(
                              "q-item",
                              { key: index, attrs: { tag: "label", link: "" } },
                              [
                                _c(
                                  "q-item-side",
                                  [
                                    _c("q-checkbox", {
                                      attrs: { val: group.value },
                                      on: { input: _vm.changeFilter },
                                      model: {
                                        value: _vm.groups,
                                        callback: function($$v) {
                                          _vm.groups = $$v
                                        },
                                        expression: "groups"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item-main",
                                  [
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass: "text-weight-light",
                                        attrs: { label: "" }
                                      },
                                      [_vm._v(_vm._s(group.label))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "q-item",
                [
                  _c("q-item-main", [
                    _c("p", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-faded",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.clearFilters()
                            }
                          }
                        },
                        [
                          _c("q-icon", { attrs: { name: "far fa-trash-alt" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("clear_filters")) +
                              "\n\t\t\t\t\t\t"
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }